<template>
  <div class="mentee-review-status-chart">
    <div class="chart-header">
      <h4 class="chart-title">Mentor Review Status</h4>
      <div class="chart-actions">
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'bar' }"
          @click="selectedView = 'bar'"
          aria-label="Bar chart view"
        >
          <i class="fa fa-bar-chart" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'pie' }"
          @click="selectedView = 'pie'"
          aria-label="Pie chart view"
        >
          <i class="fa fa-pie-chart" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          aria-label="List view"
          :class="{ active: selectedView === 'list' }"
          @click="selectedView = 'list'"
        >
          <i class="fa fa-list" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          aria-label="Download chart"
          :class="{ active: selectedView === 'download' }"
          @click="selectedView = 'download', downFunc()"
        >
          <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="chart-content-area">
      <MenteeReviewStatusBarChart 
        v-if="selectedView === 'bar' || selectedView === 'download'" 
        :barchartMentorReviewCategories="barchartMentorReviewCategories"
        :barchartMentorReviewSeries="barchartMentorReviewSeries"
        :barchartMentorReviewedSeries="barchartMentorReviewedSeries"
        :maxValue="maxValue"
        :tickAmount="tickAmount"
      />
      <MenteeReviewStatusPieChart 
        :totalMentorReviewCount="totalMentorReviewCount"
        :totalMentorReviewedCount="totalMentorReviewedCount"
        :locationDataMentorReview="locationDataMentorReview"
        v-if="selectedView === 'pie'" 
      />
      <MenteeReviewStatusList 
        :mentorReviewList="mentorReviewList"
        v-if="selectedView === 'list'" 
      />
    </div>
  </div>
</template>

<script>
import MenteeReviewStatusBarChart from '@/components/enterpriseadmin/mentee_review_status_barchart.vue';
import MenteeReviewStatusPieChart from '@/components/enterpriseadmin/mentee_review_status_piechart.vue';
import MenteeReviewStatusList from '@/components/enterpriseadmin/mentee_review_status_list.vue';
import axios from 'axios';

export default {
  props: {
    totalMentorReviewCount: {
      type: Number,
      default: 0,
    },
    totalMentorReviewedCount: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: 0,
    },
    tickAmount: {
      type: Number,
      default: 0,
    },
    locationDataMentorReview: {
      type: Array,
      default() {
        return [];
      },
    },
    barchartMentorReviewCategories: {
      type: Array,
      default() {
        return [];
      },
    },
    barchartMentorReviewSeries: {
      type: Array,
      default() {
        return [];
      },
    },
    barchartMentorReviewedSeries: {
      type: Array,
      default() {
        return [];
      },
    },
    mentorReviewList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    MenteeReviewStatusBarChart,
    MenteeReviewStatusPieChart,
    MenteeReviewStatusList,
  },
  data() {
    return {
      selectedView: 'bar',
      apiUrl: process.env.API_ENDPOINT,
    };
  },
	methods: {
		downFunc() {
			axios.get('/enterprise-admin-mentorreview-status-csv')
			.then(response => {
				var fileName = response.data;
				if (fileName) {
					var url = this.apiUrl + '/custom/csv-view/' + fileName + '/Mentor-Review-Status';
					window.location.href = url;
				}
			})
			.catch(error => {

			});
		},
	},
};
</script>

<style scoped>
.mentee-review-status-chart {
  width: 100%;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px 12px 8px 12px;
  border-bottom: 1px solid #e5e7eb;
}

.chart-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.1;
  color: #1f2937;
}

.chart-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 3px;
}

.chart-action-btn {
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #4b5563;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.chart-action-btn.active {
  color: #111827;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #d1d5db;
}

.chart-action-btn i {
  font-size: 12px;
}

.chart-content-area {
	margin-right: 20px;
	padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/mentee_review_status_chart.vue